import React, { useEffect, useRef } from 'react';

const ProjectBrandDetail = () => {

    const bannerRef = useRef(null);

    const scrollToContent = () => {
        if (bannerRef.current) {

            const bannerBottom = bannerRef.current.offsetHeight;


            window.scrollTo({
                top: bannerBottom,
                behavior: 'smooth'
            });
        }
    };


    useEffect(() => {
        const handleScroll = () => {
            if (!bannerRef.current) return;

            const bannerHeight = bannerRef.current.offsetHeight;
            const scrollY = window.scrollY;

            if (scrollY < bannerHeight - 80) {
                document.body.classList.add('nav-especial');
            } else {
                document.body.classList.remove('nav-especial');
            }
        };

        window.addEventListener('scroll', handleScroll);


        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.classList.remove('nav-especial');
        };
    }, []);


    return (
        <div className="pds-main-wrapper">
            <div className="moti-banner-full" ref={bannerRef}>
                <img
                    src="../images/Pandora/Pandora.jpg"
                    alt="Banner Principal"
                    className="moti-banner-img"
                />
                <div className="moti-banner-content">
                    <span className='moti-banner-mini'>Pandora</span>
                    <h1 className="moti-banner-title">Degradados Perfectos</h1>
                    <span
                        className='moti-banner-button'
                        onClick={scrollToContent}
                        style={{ cursor: 'pointer' }}
                    >
                        Conoce el proyecto
                        <img
                            src="../images/AE/chevron.png"
                            alt="Banner Principal"
                            className="moti-banner-extra"
                        />
                    </span>
                </div>
            </div>
            <div className="pds-content-card">
                {/* Header con indicadores */}
                <header className="pds-header-group">
                    <img
                        src="/images/logo/MotiPuntos.svg"
                        alt="dots"
                        className="blog-moti-dots"
                    />
                    <p className="pds-label-top">CONOCE EL PROYECTO</p>
                    <h1 className="pds-main-title">Conociendo la marca y sus objetivos</h1>
                </header>

                <div className="pds-sections-container">
                    {/* Bloque 1: American Eagle */}
                    <div className="pds-feature-block">
                        <div className="pds-text-column">
                            <span className="pds-badge pds-bg-mint"> <img src="../images/AE/r.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading">Pandora</h2>
                            <p className="pds-description">
                                Pandora es una marca global de joyería reconocida por su diseño contemporáneo, 
                                su identidad sofisticada y sus estrictos estándares de imagen a nivel internacional. 
                                Para este proyecto, el objetivo fue ejecutar una intervención de visual merchandising 
                                precisa y alineada a sus lineamientos globales, garantizando consistencia visual en cada tienda.
                                <br /> <br />


                                <span className="pds-badge pds-bg-peach"><img src="../images/AE/trazo.png" alt="Img 1" /></span>
                                <h2 className="pds-section-heading">Entendiendo el espacio para diseñar con propósito</h2>
                                El proyecto se implementó en escaparates de tiendas Pandora dentro de centros comerciales, 
                                espacios donde la claridad visual, la transparencia y la correcta lectura de marca son esenciales. 
                                Se consideraron factores como iluminación, reflejos y visibilidad desde el exterior para asegurar 
                                una comunicación limpia y elegante.

                            </p>
                        </div>
                        <div className="pds-visual-stack pds-bg-guide-mint">
                            <div className="pds-img-holder pds-rotate-left">
                                <img src="../images/Pandora/Pandora (8).jpg" alt="Img 1" />
                            </div>

                            <div className="pds-img-holder pds-center">
                                <img src="../images/Pandora/Pandora (6).jpg" alt="Img 2" />
                            </div>

                            <div className="pds-img-holder pds-rotate-right pds-overlay">
                                <img src="../images/Pandora/Pandora (4).jpg" alt="Img 3" />
                            </div>
                        </div>
                    </div>

                    {/* Bloque 2: Espacio (Invertido) */}
                    <div className="pds-feature-block pds-row-reverse">
                        <div className="pds-text-column-rigth">
                            <span className="pds-badge pds-bg-grape"><img src="../images/AE/foco.png" alt="Img 1" /></span>
                            <h2 className="pds-section-heading rigth">De la Idea a lo  <br /> tangible: Producción y Acabados</h2>
                            <p className="pds-description rigth">
                               La ejecución incluyó la producción de vinil ópticamente transparente impreso con triple strike de color, 
                               sin camas de blanco, para lograr el tono exacto requerido por la marca. 
                               Esta técnica permitió una integración perfecta sobre cristal, 
                               manteniendo profundidad de color y una apariencia premium.

                            </p>
                        </div>
                        <div className="pds-visual-grid">
                            <img src="../images/Pandora/Pandora (9).jpg" className="pds-grid-img img1" alt="Store view" />
                            <img src="../images/Pandora/Pandora (5).jpg" className="pds-grid-img img2" alt="Close up" />
                        </div>
                    </div>

                    <div className="pds-bottom-block ">
                        <span className="pds-badge pds-bg-salmon"><img src="../images/AE/can.png" alt="Img 1" /></span>
                        <h2 className="pds-section-heading rigth">¿Por qué elegimos estos materiales?</h2>
                        <p className="pds-description rigth">
                            Los materiales fueron seleccionados para cumplir con los estándares globales de imagen de Pandora. 
                            El vinil ópticamente transparente, combinado con una gestión de color precisa en Pantone, 
                            garantizó fidelidad cromática y una estética limpia. Las figuras de estireno aportaron soporte 
                            visual y estructura, manteniendo ligereza y elegancia en el diseño.
                        </p>
                        <img src="../images/Pandora/Pandora (10).jpg" className="bannerAE" alt="Close up" />
                    </div>
                    <div className="moti-container">
                        {/* Bloque: El Resultado */}
                        <section className="moti-section moti-center">
                            <div className="moti-icon-box moti-pink">
                                <span className="moti-icon"><img src="../images/AE/badge.png" alt="Img 1" /></span>
                            </div>
                            <h2 className="moti-title">El resultado: Impacto en el punto de venta</h2>
                            <p className="moti-description">
                                El resultado fue un escaparate alineado al 100 % con la identidad de Pandora, 
                                con una comunicación clara, sofisticada y de alto impacto visual. 
                                La correcta reproducción del color y la transparencia del material permitieron que el producto destacara, 
                                mejorando la experiencia visual del cliente en tienda.
                            </p>
                        </section>

                        {/* Bloque: Servicios y Stack de Imágenes */}
                        <section className="moti-services-layout">
                            <div className="moti-services-text">
                                <h3 className="moti-subtitle">Servicios representados en este proyecto:</h3>

                            </div>
                            <div>
                                <ul className="moti-list">
                                    <li>• Desarrollo y ejecución de proyectos</li>
                                    <li>• Producción especializada</li>
                                    <li>• Instalación en punto de venta</li>
                                    <li>• Coordinación comercial para objetivos visuales</li>
                                </ul>
                            </div>
                        </section>
                        <div className="moti-image-stack">
                            <img src="../images/Pandora/Pandora (9).jpg" alt="Domelipa AE" className="moti-img-card moti-tilt-left" />
                            <img src="../images/Pandora/Pandora (1).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-right " />
                            <img src="../images/Pandora/Pandora (2).jpg" alt="American Eagle Neon" className="moti-img-card moti-tilt-center" />
                        </div>

                        {/* Bloque: Destaque de Portafolio */}
                        <section className="moti-section moti-center">
                            <h2 className="moti-title">¿Por qué este proyecto destaca en<br /> nuestro portafolio?</h2>
                            <img
                                src="/images/logo/MotiPuntos.svg"
                                alt="dots"
                                className="blog-moti-dots"
                            />
                            <p className="moti-description">
                               Este caso demuestra nuestra capacidad para ejecutar proyectos bajo estándares internacionales, 
                               cuidando cada detalle técnico y visual. Destaca por la precisión en color, 
                               la calidad de los materiales y la eficiencia operativa, 
                               con instalaciones de aproximadamente 1 hora por tienda, 
                               respaldadas por pruebas previas en planta para garantizar la calidad final.
                            </p>
                        </section>

                        {/* Footer Logo */}
                        <footer className="moti-brand-footer">
                            <img src="../images/AE/moti.png" alt="Img 1" className='moti-lgo' />
                            <img src="../images/AE/ready.png" alt="Img 1" className='ready' />
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectBrandDetail;